import React from 'react';
import SectionContainer from 'components/Containers/SectionContainer';
import { Row } from 'components/Containers/Row/Row';
import Label from 'components/form/Label/Label';
import $t from 'locales/en/translation';
import HomeLoanInfoCard from '../components/HomeLoanInfoCard';

const HomeMortgageRefinanceModuleView = props => {
  return (
    <SectionContainer>
      <Row>
        <Label
          datatestid={`${props.datatestid}-startRefinance-title`}
          type="H3"
          typeHeader={'h3'}
          className="margB40"
        >
          {$t.howToStartRefinancing}
        </Label>
        <HomeLoanInfoCard
          title={$t.calculateHowMuchIcanAffort}
          detail={$t.calculateHowMuchIcanAffortInfo}
          classname="calculatorIcon"
          datatestid={`${props.datatestid}-howMuchYouCanAfford-refinance`}
        />
        <div className="margB40" />
        <HomeLoanInfoCard
          title={$t.gatherDocuments}
          detail={$t.documentsLenderWillAsk}
          datatestid={`${props.datatestid}-lenderDocuments-refinance`}
          classname="documentsIcon"
        />
        <div className="margB40" />
        <HomeLoanInfoCard
          title={$t.chooseRighLender}
          detail={props?.config?.home_loan?.about_refinance?.right_lender}
          classname="homelenderIcon"
          datatestid={`${props.datatestid}-findALender-refinance`}
        />
      </Row>
    </SectionContainer>
  );
};

export default HomeMortgageRefinanceModuleView;
